import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Navigation from './components/Navigation';
import ProtectedRoute from './components/ProtectedRoute';
import useBackspaceNavigation from './hooks/useBackspaceNavigation';
import HomePage from './pages/HomePage';
import ProblemPage from './pages/ProblemPage';
import ProblemViewPage from './pages/ProblemViewPage';
import SourcePage from './pages/SourcePage';
import CurriculumTopicPage from './pages/CurriculumTopicPage';
import TechniquePage from './pages/TechniquePage';
import AuthPage from './pages/AuthPage';

function AppContent() {
    // Enable backspace navigation globally
    useBackspaceNavigation();

    return (
        <>
            <Navigation />
            <Routes>
                <Route path="/auth" element={<AuthPage />} />
                <Route
                    path="/"
                    element={
                        <ProtectedRoute>
                            <HomePage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/problems/new"
                    element={
                        <ProtectedRoute>
                            <ProblemPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/problems/:id"
                    element={
                        <ProtectedRoute>
                            <ProblemPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/problems/view/:id"
                    element={
                        <ProtectedRoute>
                            <ProblemViewPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/sources"
                    element={
                        <ProtectedRoute>
                            <SourcePage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/curriculum-topics"
                    element={
                        <ProtectedRoute>
                            <CurriculumTopicPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/techniques"
                    element={
                        <ProtectedRoute>
                            <TechniquePage />
                        </ProtectedRoute>
                    }
                />
            </Routes>
        </>
    );
}

function App() {
    return (
        <AuthProvider>
            <Router>
                <AppContent />
            </Router>
        </AuthProvider>
    );
}

export default App;
